export const UPDATE_OCR_MODERATION_SERVICE_REQUEST = 'UPDATE_OCR_MODERATION_SERVICE_REQUEST';
export const UPDATE_OCR_MODERATION_SERVICE_SUCCESS = 'UPDATE_OCR_MODERATION_SERVICE_SUCCESS';
export const UPDATE_OCR_MODERATION_SERVICE_FAILED = 'UPDATE_OCR_MODERATION_SERVICE_FAILED';

export const GET_OCR_MODERATION_SERVICE_REQUEST = 'GET_OCR_MODERATION_SERVICE_REQUEST';
export const GET_OCR_MODERATION_SERVICE_SUCCESS = 'GET_OCR_MODERATION_SERVICE_SUCCESS';
export const GET_OCR_MODERATION_SERVICE_FAILED = 'GET_OCR_MODERATION_SERVICE_FAILED';
